import { Box, Button, Center, Heading, Text } from '@chakra-ui/react';
import { HiOutlineTicket } from 'react-icons/hi2';
import { Link as ScrollLink } from 'react-scroll';
import getStaticAsset from '../../../../../helper/utils/utilsStaticAsset';

export default function HeroSection({ hero }) {
    return (
        <Box w='full' h='450px' bg='white' my={4} rounded='xl' bgImage={getStaticAsset(hero['image'])} bgSize='cover' bgRepeat='no-repeat' bgPosition='top' overflow='hidden'>
            <Box w='full' h='full' bgGradient='linear(to-t, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.3))'>
                <Center w={{ base: '90%', md: '50%' }} mx='auto' h='full' flexDirection='column'>
                    <Heading textAlign='center' color='white' fontSize={{ base: '4xl', md: '5xl' }} textTransform='uppercase'>
                        {hero['headline']}
                    </Heading>
                    <Text textAlign='center' color='white' mt={3}>
                        {hero['subheadline']}
                    </Text>
                    <Button as={ScrollLink} to='product' smooth={true} offset={-200} duration={300} isDynamic={true} leftIcon={<HiOutlineTicket />} w='max-content' px={7} py={6} colorScheme='primary' mt={14} cursor='pointer'>
                        {hero['ctaTitle']}
                    </Button>
                </Center>
            </Box>
        </Box>
    );
}
